export default __webpack_public_path__ + "static/media/logo-motor-volta-2x.f7ef8154.png";